<div class="max-w-[443px]">
    <h1 mat-dialog-title class="flex items-center gap-2 font-medium text-[22px] m-0 pt-3 pb-2 p-4 text-red-900 dark:text-red-400">
        <mat-icon class="icon-size-6 material-symbols-rounded text-red-600 dark:text-red-300">error</mat-icon>
        {{ title }}
    </h1>
    
    <mat-divider class="dark:border-gray-700"></mat-divider>
    
    <mat-dialog-content class="m-0 p-4 text-red-900 dark:text-red-50">
        <div class="dialog-content-box bg-red-50 dark:bg-red-900 p-4 rounded-lg">
            <span class="text-lg break-words" [innerHTML]="content"></span>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="flex flex-row gap-3 justify-end m-0 pt-3 p-4">
        <button *ngFor="let button of buttons" 
            mat-stroked-button 
            class="m-0 dialog-action-button dark:text-white dark:border-neutral-990"
            [ngClass]="button.class" 
            [ngStyle]="button.style"
            (click)="button.action()"
        >
            {{ button.label }}
        </button>
    </mat-dialog-actions>
</div>